(function () {
  'use strict';
  if (window.__dtMainCart) return;
  window.__dtMainCart = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false, again = false;

  function root() { return document.querySelector('[data-dtc]'); }

  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  // redraw the section (and the header cart bubble) with the Section Rendering API, no page reload
  function refresh() {
    var el = root();
    if (!el) return Promise.resolve();
    var id = el.getAttribute('data-section-id');
    var opts = { credentials: 'same-origin' };
    var path = window.location.pathname;
    var section = fetch(path + '?section_id=' + id, opts)
      .then(function (r) { if (!r.ok) throw new Error('section'); return r.text(); })
      .then(function (html) {
        var wrap = document.getElementById('shopify-section-' + id);
        var sec = parse(html).querySelector('.shopify-section');
        if (wrap && sec) wrap.innerHTML = sec.innerHTML;
      });
    var bubble = fetch(path + '?sections=cart-icon-bubble', opts)
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (s) {
        var el = document.getElementById('cart-icon-bubble');
        if (el && s['cart-icon-bubble']) {
          var b = parse(s['cart-icon-bubble']).querySelector('.shopify-section');
          if (b) el.innerHTML = b.innerHTML;
        }
      })
      .catch(function () {});
    return Promise.all([section, bubble]).catch(function () { window.location.reload(); });
  }

  function setLoading(on) { var el = root(); if (el) el.classList.toggle('is-loading', on); }

  function change(li, quantity) {
    if (busy) return;
    busy = true;
    setLoading(true);
    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: li.getAttribute('data-key'), quantity: quantity })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var err = li.querySelector('[data-dtc-error]');
          if (err) err.textContent = (res.body && (res.body.description || res.body.message)) || '';
          var input = li.querySelector('[data-dtc-input]');
          if (input) input.value = li.getAttribute('data-qty');
          return;
        }
        return refresh();
      })
      .catch(function () { window.location.reload(); })
      .then(function () {
        busy = false;
        setLoading(false);
        if (again) { again = false; refresh(); }
      });
  }

  function qtyOf(li) { return parseInt(li.getAttribute('data-qty'), 10) || 0; }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var li = t.closest('[data-dtc] .dtc-item');
    if (!li) return;
    if (t.closest('[data-dtc-remove]')) { e.preventDefault(); change(li, 0); }
    else if (t.closest('[data-dtc-plus]')) { e.preventDefault(); change(li, qtyOf(li) + 1); }
    else if (t.closest('[data-dtc-minus]')) { e.preventDefault(); change(li, Math.max(1, qtyOf(li) - 1)); }
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-dtc-input]')) return;
    var li = input.closest('.dtc-item');
    var q = parseInt(input.value, 10);
    if (!li || isNaN(q) || q < 0) { if (li) input.value = li.getAttribute('data-qty'); return; }
    if (q !== qtyOf(li)) change(li, q);
  });

  // gift sync changed the cart: redraw
  document.addEventListener('dt:gifts-synced', function () {
    if (busy) { again = true; return; }
    refresh();
  });
})();
